import {PaginatedResponseType} from "../../../Types/Response/PaginatedResponseType";
import {useInfinitePostage} from "../../../Api/PostageEndpoints";
import {PostageItemType, PostageUsageType} from "../../../Types/PostageType";
import {allowedPostage} from "../../../Api/StandaloneSendsEndpoints";
import ComboBoxControl from "../../../Framework/Components/Forms/ComboBox/ComboBoxControl";
import CountryCodeFlag from '../../../Framework/Components/CountryCodeFlag';

type SendsPostageControlType = {
    countryCode: string;
    label: string;
    name: string;
    control: any;
    unregister: any;
    getValues: any;
    defaultValues?: any;
    reset?: boolean;
}

const SendsPostageControl = (props: SendsPostageControlType) => {
    const { isLoading: postageLoading, data: postageData, error: postageError } : { isLoading: boolean, data: PaginatedResponseType | any, error: any } = useInfinitePostage(props.countryCode, PostageUsageType.SendsPages);

    if(!props.countryCode) return null;

    const PostageOptions = postageData?.pages.map((page: any) => page?.data && page.data.filter((postage: PostageItemType, index: number) =>(
        { 'label': postage.label, 'value': postage.value }
    )))[0];

    return (
        <div className={'form-group'}>
            <label className={'postage-label'}>
                <CountryCodeFlag countryCode={props.countryCode} style={{ marginInlineEnd: 'var(--xs-unit)', fontStyle: 'normal', fontSize: '2em' }} />{props.countryCode === 'GB' ? 'UK' : props.countryCode} Postage Options
            </label>

            <ComboBoxControl
                name={props.name}
                label={`Postage Options for ${props.countryCode}`}
                placeholder={`Select Postage...`}
                data={PostageOptions}
                defaultValues={props.defaultValues}
                isLoading={postageLoading}
                valueType={'number'}
                minimal={true}
                required={true}
                reset={props.reset}
            />
        </div>
    )
}

export default SendsPostageControl
